"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRubricHook = void 0;
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var context_1 = require("../../../../api/context");
var use_mount_hook_1 = require("../../../../api/hooks/use-mount.hook");
var learnosity_constants_1 = require("../../../Constants/learnosity.constants");
var AtomicAlertManagerContext_1 = require("../../AtomicAlert/AtomicAlertManagerContext");
var useRubricHook = function (_a) {
    var rubricReference = _a.rubricReference, _b = _a.requestSignedCallback, requestSignedCallback = _b === void 0 ? null : _b, curriculumId = _a.curriculumId;
    // ------------------ Context
    var learnosityService = (0, react_1.useContext)(context_1.ServiceContext).learnosityService;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    // ------------------ State
    var _c = (0, react_1.useState)(false), initialized = _c[0], setInitialized = _c[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    // ------------------ Methods
    var initialize = function () {
        learnosityService
            .signPreviewItemsRequest([rubricReference], curriculumId)
            .then(function (signedRequest) {
            var learnosityApi = window[learnosity_constants_1.LEARNOSITY_ITEMS_API];
            learnosityApi.init(signedRequest, {
                readyListener: function () {
                    var lrnRatingbuttons = document.getElementsByClassName('lrn_ratingButton');
                    for (var _i = 0, lrnRatingbuttons_1 = lrnRatingbuttons; _i < lrnRatingbuttons_1.length; _i++) {
                        var button = lrnRatingbuttons_1[_i];
                        button.addEventListener('click', function (e) {
                            e.stopPropagation();
                        });
                    }
                    requestSignedCallback ? setTimeout(requestSignedCallback, 500) : '';
                },
            });
            setInitialized(true);
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('common.errorMessages.oopsErr'),
                    message: t('common.errorMessages.viewRubric'),
                },
            });
        });
    };
    (0, use_mount_hook_1.useMount)(function () {
        initialize();
    });
    return { initialized: initialized };
};
exports.useRubricHook = useRubricHook;
